import React, { useEffect, useState } from "react";
import ProgressBar from "@ramonak/react-progress-bar";
import Web3 from "web3";
import Web3Modal from "web3modal";
import { Alert, Button, FormControl, InputGroup } from "react-bootstrap";
import axios from "axios";
import erc20Abi from "./contracts/abis/erc20.abi.json";
import Pledge from "./contracts/abis/Pledge.abi.json";
import ClipLoader from "react-spinners/ClipLoader";
import { css } from "@emotion/react";

export default function App() {
  const [loading, setLoading] = useState(false);
  const [address, setAddress] = useState("");
  const [web3, setWeb3] = useState(null);
  const [web3Modal, setWeb3Modal] = useState();
  const [provider, setProvider] = useState(null);
  const [networkId, setNetworkId] = useState(1);
  const [chainId, setChainId] = useState();
  // alert
  const [alertMessage, setAlertMessage] = useState("");
  const [alertVariant, setAlertVariant] = useState("error");
  const [showAlert, setShowAlert] = useState(false);
  const [selectedPaymentOption, setSelectedPaymentOption] = useState("kcs");
  const [kcsPrice, setKcsPrice] = useState(0);
  const [userAmount, setUserAmount] = useState();
  const [totalPledged, setTotalPledged] = useState(0);
  const [percentageCompleted, setPercentageCompleted] = useState(0);
  const goal = 75000;
  // contracts

  const [paddWhitelistContract, setPaddWhitelistContract] = useState();
  const [usdtContract, setUsdtContract] = useState();
  // contract addresses
  const ERC20_DECIMALS = 18;
  const KCS_ETH_CONTRACT_ADDRESS = "0xf34960d9d60be18cc1d5afc1a6f012a723a28811";
  const USDT_KCC_CONTRACT_ADDRESS =
    "0x0039f574eE5cC39bdD162E9A88e3EB1f111bAF48";

  const paddWhitelistContractAddress =
    "0xe85C0027215BC7f9868E9Be916A09B1A120600ee";

  // chain ids
  const kccMainNet = 321;
  const kccTestNet = 322;

  const currentNetwork = kccMainNet;

  const networks = {
    321: "KCC Smart Chain Mainnet",
    322: "KCC Smart Chain Testnet",
    5777: "Local development blockchain",
  };

  let [color, setColor] = useState("#ffffff");
  const override = css`
    display: block;
    margin: 0 auto;
    border-color: white;
  `;

  // get current KCS price
  const getCryptoPrice = async () => {
    await axios
      .get(
        `https://api.coingecko.com/api/v3/simple/token_price/ethereum?contract_addresses=${KCS_ETH_CONTRACT_ADDRESS}&vs_currencies=usd`
      )
      .then((response) => {
        // console.log(Object.values(response.data)[0].usd);
        setKcsPrice(Object.values(response.data)[0].usd);
      })
      .catch((err) => console.log(err));
  };
  // Initialize web3 with given provider
  const initWeb3 = (provider) => {
    const web3 = new Web3(provider);

    web3.eth.extend({
      methods: [
        {
          name: "chainId",
          call: "eth_chainId",
          outputFormatter: web3.utils.hexToNumber,
        },
      ],
    });
    return web3;
  };
  const pledgeUSDT = async (amount) => {
    if (amount > 11000) {
      return setAlert(
        "danger",
        "You can only purchase PADD Token worth $11000 and below! you can purchase more on public listing."
      );
    }
    setLoading(true);
    try {
      const userPledge = await paddWhitelistContract.methods
        .getPledge(address)
        .call();
      console.log(userPledge);
      if (Number(userPledge) === 0) {
        //  allow contract to transfer token to admin wallet
        await usdtContract.methods
          .approve(
            paddWhitelistContractAddress,
            // USDT_KCC_CONTRACT_ADDRESS,
            web3.utils.toWei(amount.toString())
          )
          .send({ from: address });

        // send transaction
        // play game
        await paddWhitelistContract.methods
          .pledgeUsdt(amount)
          .send({ from: address });
        setAlert("success", "Payment Successful");
      } else {
        setAlert("danger", "you have already pledged");
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);

      console.log(error);
    }
  };
  const pledgeKCS = async (amount) => {
    if (amount > 11000) {
      return setAlert(
        "danger",
        "You can only purchase PADD Token worth $11000 and below! You can purchase more on public listing."
      );
    }
    setLoading(true);

    const amountInDollars = parseFloat(amount);
    try {
      const userPledge = await paddWhitelistContract.methods
        .getPledge(address)
        .call();
      console.log(userPledge);
      if (Number(userPledge) === 0) {
        await paddWhitelistContract.methods.pledgeKcs(amountInDollars).send(
          {
            from: address,
            to: paddWhitelistContract,
            //divide current amountInDollars by amount to get amount of kcs user is pledging
            value: web3.utils.toWei(
              (amountInDollars / kcsPrice).toString(),
              "ether"
            ),
          },
          (err, transactionId) => {
            // if (err) {
            //   console.log("Payment failed", err);
            // } else {
            //   console.log("Payment successful", transactionId);
            // }
          }
        );
        setAlert("success", "Payment Successful");
      } else {
        setAlert("danger", "you have already pledged");
      }
    } catch (error) {
      console.log(error);
      console.log(Object.keys(error)[0]);
      console.log(Object.values(error)[0]);
      setAlert("danger", "Failed! Try Again");
      setLoading(false);
    }

    setLoading(false);
  };

  useEffect(() => {
    const web3Modal = new Web3Modal({
      network: "main",
      cacheProvider: true,
    });
    setWeb3Modal(web3Modal);

    if (web3Modal.cachedProvider) {
      onConnect();
    }
    getCryptoPrice();
  }, []);

  const truncateAddress = (address) => {
    return (
      address.slice(0, 5) +
      "..." +
      address.slice(address.length - 4, address.length)
    );
  };

  const setAlert = (variant, message) => {
    setAlertMessage(message);
    setAlertVariant(variant);
    if (variant) setShowAlert(true);
    else setShowAlert(false);
  };

  const updatePercentage = async (contract) => {
    // get total amount pledged
    const totalPledged = await contract.methods.getTotalPledge().call();

    setTotalPledged(totalPledged);

    // set percentage
    const percentage = ((totalPledged / goal) * 100).toFixed(2);
    setPercentageCompleted(percentage);
  };
  const onConnect = async () => {
    const web3Modal = new Web3Modal({
      cacheProvider: true,
    });

    // init provider
    const provider = await web3Modal.connect();
    setProvider(provider);
    subscribeProvider(provider);

    // set web3
    const web3 = initWeb3(provider);
    setWeb3(web3);

    // set user address
    const accounts = await provider.request({ method: "eth_requestAccounts" });
    setAddress(accounts[0]);

    const networkId = await provider.request({ method: "net_version" });
    setNetworkId(networkId);

    // initialize contracts
    let chainId = parseInt(await web3.eth.getChainId());
    setChainId(chainId);

    if (chainId !== currentNetwork) {
      // request user add kcc to metamask
      const targetNetwork = networks[currentNetwork.toString()];

      try {
        if (provider)
          await provider.request({
            method: "wallet_addEthereumChain",
            params: [
              {
                chainId: currentNetwork === kccMainNet ? "0x141" : "0x142",
                chainName: networks[currentNetwork.toString()],
                nativeCurrency: {
                  name: "KCS",
                  symbol: "KCS",
                  decimals: 18,
                },
                rpcUrls: [
                  currentNetwork === kccMainNet
                    ? "https://rpc-mainnet.kcc.network"
                    : "https://rpc-testnet.kcc.network",
                ],
                blockExplorerUrls: [
                  currentNetwork === kccMainNet
                    ? "https://explorer.kcc.io/en"
                    : "https://scan-testnet.kcc.network",
                ],
              },
            ],
          });

        const newNetworkID = await provider.request({
          method: "net_version",
        });
        setNetworkId(newNetworkID);
        setAlert();
      } catch (error) {
        console.log({ error });
        return `Wrong network, please switch to ${targetNetwork} to interact with Elesaro`;
      }
    }
    // fetch chain id again
    chainId = parseInt(await web3.eth.getChainId());
    if (chainId === currentNetwork) {
      const contract = new web3.eth.Contract(
        Pledge.abi,
        paddWhitelistContractAddress
      );
      setPaddWhitelistContract(contract);
      // listen for events

      contract.once(
        "kcsPledged",
        {},
        {
          fromBlock: 3918999,
          toBlock: "latest",
        },
        function (error, event) {
          // update dice values

          // console.log(event.returnValues["0"]);
          console.log(event);
          updatePercentage(contract);
        }
      );
      contract.once(
        "usdtPledged",
        {},
        {
          fromBlock: 3918999,
          toBlock: "latest",
        },
        function (error, event) {
          // update dice values

          console.log(event);
          updatePercentage(contract);
        }
      );

      const usdtContract = new web3.eth.Contract(
        erc20Abi,
        USDT_KCC_CONTRACT_ADDRESS
      );
      setUsdtContract(usdtContract);

      // get total amount pledged
      const totalPledged = await contract.methods.getTotalPledge().call();

      setTotalPledged(totalPledged);
      updatePercentage(contract);
    }
    setAlert();
  };

  const subscribeProvider = async (provider) => {
    if (!provider.on) {
      return;
    }
    provider.on("close", () => resetApp());
    provider.on("accountsChanged", async (accounts) => {
      setAddress(accounts[0]);
    });
    // Subscribe to chainId change
    provider.on("chainChanged", async (chainId) => {
      onConnect();
    });

    provider.on("networkChanged", async (networkId) => {
      onConnect();
    });
  };

  const resetApp = async () => {
    if (web3 && web3.currentProvider && web3.currentProvider.close) {
      await web3.currentProvider.close();
    }
    if (provider.close) {
      await provider.close();
      setProvider(null);
    }
    await web3Modal.clearCachedProvider();

    setWeb3(null);

    setAddress(null);

    setNetworkId(null);

    localStorage.clear();
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const chainId = parseInt(await web3.eth.getChainId());
    // ensure user is on appropriate network

    if (chainId !== currentNetwork) {
      const targetNetwork = networks[currentNetwork.toString()];
      return setAlert(
        "danger",
        `Unsupported Network! Please switch to ${targetNetwork}`
      );
    }
    // clear error
    setAlert();
    // proceed to make payment

    // user is on KCC chain
    // KCS
    if (selectedPaymentOption === "kcs") {
      pledgeKCS(userAmount); //user paying in kcs
    }
    // USDT
    if (selectedPaymentOption === "usdt") {
      pledgeUSDT(parseFloat(userAmount)); //user paying in usdt
    }
  };

  return (
    <div className="main">
      {/* ***** Header Start ***** */}
      <header id="header">
        {/* Navbar */}
        <nav
          data-aos="zoom-out"
          data-aos-delay={800}
          className="navbar navbar-expand"
        >
          <div className="container header">
            {/* Navbar Brand*/}
            <a className="navbar-brand" href="/">
              <img
                className="navbar-brand-sticky"
                src="/assets/img/logo/logo.png"
                alt="sticky brand-logo"
              />
            </a>
            <div className="ml-auto" />
            {/* Navbar */}
            <ul className="navbar-nav items mx-auto">
              <li className="nav-item">
                <a className="nav-link" href="/">
                  Home
                </a>
              </li>
              <li className="nav-item ">
                <a
                  className="nav-link"
                  target="_blank"
                  rel="norefferer"
                  href="https://padd.finance/download/215/"
                >
                  Lite Paper
                </a>
              </li>
            </ul>

            {/* Navbar Icons */}
            <ul className="navbar-nav icons">
              <li className="nav-item">
                {/*<a
                  href="#"
                  className="nav-link"
                  data-toggle="modal"
                  data-target="#search"
                >
                  <i className="fas fa-search" />
                </a> */}
              </li>
            </ul>
            {/* Navbar Toggler */}
            <ul className="navbar-nav toggle">
              <li className="nav-item">
                <a
                  href="#"
                  className="nav-link"
                  data-toggle="modal"
                  data-target="#menu"
                >
                  <i className="fas fa-bars toggle-icon m-0" />
                </a>
              </li>
            </ul>
            {/* Navbar Action Button */}
            <ul className="navbar-nav action">
              {address ? (
                <li className="nav-item ml-3">
                  <a
                    href
                    className="btn ml-lg-auto btn-bordered-white"
                    onClick={resetApp}
                  >
                    {/* <i class="far fa-times-circle mr-md-2"/> */}
                    {chainId
                      ? chainId === currentNetwork
                        ? truncateAddress(address)
                        : "Unsupported chain "
                      : "..."}
                  </a>
                </li>
              ) : (
                <li className="nav-item ml-3">
                  <a
                    href
                    className="btn ml-lg-auto btn-bordered-white"
                    onClick={onConnect}
                  >
                    <i className="icon-wallet mr-md-2" />
                    Wallet Connect
                  </a>
                </li>
              )}
            </ul>
            <ul className="navbar-nav action">
              <li className="nav-item ml-3">
                <img
                alt ="image"
                  src="https://static.explorer.kcc.io/group1/M00/02/CA/rB8lrmD-GimAZRfPAABTZQt_JuU724.jpg"
                  height="50px"
                  width="50px"
                  style={{
                    borderRadius: "25px",
                    cursor: "pointer",
                  }}
                  onClick={async () => {
                    // add padd token to metamask
                    await provider.request({
                      method: "wallet_watchAsset",
                      params: {
                        type: "ERC20", // Initially only supports ERC20, but eventually more!
                        options: {
                          address: "0x1e2fbb76c8daf5a0a8f91388bac09511f3d7ac62", // The address that the token is at.
                          symbol: "PAD", // A ticker symbol or shorthand, up to 5 chars.
                          decimals: 18, // The number of decimals in the token
                          image:
                            "https://static.explorer.kcc.io/group1/M00/02/CA/rB8lrmD-GimAZRfPAABTZQt_JuU724.jpg", // A string url of the token logo
                        },
                      },
                    });
                  }}
                />
              </li>
            </ul>
          </div>
        </nav>
      </header>
      {/* ***** Header End ***** */}
      {/* ***** Hero Area Start ***** */}
      {/* <section className="hero-section"> */}
      <section className="item-details-area">
        <div className="container">
          <div className="row justify-content-between">
            <div className="col-12 col-lg-5">
              <div className="item-info">
                <div className="item-thumb text-center">
                  <img src="/assets/img/padd.jpg" alt="" />
                </div>
                <div className="card no-hover countdown-times my-4">
                  <div
                    className="countdown d-flex justify-content-center"
                    data-date="2022-03-30"
                  />
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-6">
              {/* Content */}
              <div className="content mt-5 mt-lg-0">
                <h3 className="m-0">Padd Finance</h3>
                <p>
                  Padd Finance is the next generation community launchpad for
                  kucoin community chain projects. With Padd Finance, token
                  holders gain access to Pre-sale, Swap and Our Padd labs
                  program
                </p>
                {/* Owner */}

                {/* Item Info List */}
                <div className="item-info-list mt-4">
                  <ul className="list-unstyled">
                    <li className="">
                      <h5>Hardcap : 7,500 KCS</h5>
                      <h5>Softcap : 5,000 KCS</h5>
                    </li>
                    <li>{/* <span>14000 x 14000 px</span> */}</li>
                    <li>
                      <h5>
                        Amount Raised :{" "}
                        {kcsPrice > 0
                          ? parseFloat(totalPledged / kcsPrice).toFixed(2)
                          : 0.0}{" "}
                        KCS
                      </h5>

                      {/* <span>64.1</span> */}

                      <div
                        style={{
                          paddingTop: 10,
                          paddingBottom: 10,
                        }}
                      >
                        <ProgressBar
                          height={15}
                          bgColor="#fc6600"
                          labelSize={12}
                          completed={percentageCompleted}
                        />
                      </div>
                    </li>
                  </ul>
                </div>

                <form onSubmit={onSubmit}>
                  <label for="amount">Amount in USD:</label>
                  <InputGroup>
                    <FormControl
                      className="form-group"
                      style={{
                        color: "#fc6600",
                        borderColor: ": var(--primary-p-color)",
                        backgroundColor: "transparent",
                      }}
                      placeholder="Enter amount in USD"
                      type="number"
                      id="amount"
                      value={userAmount}
                      onChange={(e) => setUserAmount(e.target.value)}
                      required
                    ></FormControl>
                    <InputGroup.Text
                      className="form-group"
                      style={{
                        color: "#fc6600",
                        borderColor: ": var(--primary-p-color)",
                        backgroundColor: "transparent",
                      }}
                    >
                      {kcsPrice > 0 && userAmount > 0
                        ? parseFloat(userAmount / kcsPrice).toFixed(2)
                        : 0.0}
                      KCS
                    </InputGroup.Text>
                  </InputGroup>

                  <div class="form-group mt-3">
                    <label for="sel1">Select Mode of Payment:</label>
                    <select
                      className="form-group"
                      id="sel1"
                      style={{
                        color: "var(--primary-p-color)",
                        borderColor: ": var(--primary-p-color)",
                      }}
                      onChange={(e) => setSelectedPaymentOption(e.target.value)}
                    >
                      <option value="kcs">KCS</option>
                      <option value="usdt">USDT</option>
                    </select>
                  </div>
                  {showAlert && (
                    <Alert
                      key="alert"
                      variant={alertVariant}
                      onClose={() => {
                        setAlert();
                      }}
                      dismissible
                    >
                      <Alert.Heading>
                        {alertVariant === "danger" ? "Error" : "Success"}
                      </Alert.Heading>
                      <p>{alertMessage}</p>
                    </Alert>
                  )}
                  <Button
                    className={"d-block btn btn-bordered-white mt-2 w-100"}
                    disabled={!networkId || loading}
                    type="submit"
                    value="submit"
                  >
                    {loading ? (
                      <ClipLoader
                        color={color}
                        loading={loading}
                        css={override}
                        size={25}
                      />
                    ) : (
                      "Pay"
                    )}
                  </Button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Shape */}
      <div className="shape">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1440 465"
          version="1.1"
        >
          <defs>
            <linearGradient
              x1="49.7965246%"
              y1="28.2355058%"
              x2="49.7778147%"
              y2="98.4657689%"
              id="linearGradient-1"
            >
              <stop stopColor="rgba(252,102,0, 0.15)" offset="0%" />
              <stop stopColor="rgba(235,0,169, 0.15)" offset="100%" />
            </linearGradient>
          </defs>
          <g
            id="Page-1"
            stroke="none"
            strokeWidth={1}
            fill="none"
            fillRule="evenodd"
          >
            <polygon points fill="url(#linearGradient-1)">
              <animate
                id="graph-animation"
                xmlns="http://www.w3.org/2000/svg"
                dur="2s"
                repeatCount
                attributeName="points"
                values="0,464 0,464 111.6,464 282.5,464 457.4,464 613.4,464 762.3,464 912.3,464 1068.2,464 1191.2,464 1328.1,464 1440.1,464 1440.1,464 0,464; 0,464 0,367 111.6,323.3 282.5,373 457.4,423.8 613.4,464 762.3,464 912.3,464 1068.2,464 1191.2,464 1328.1,464 1440.1,464 1440.1,464 0,464; 0,464 0,367 111.6,263 282.5,336.6 457.4,363.5 613.4,414.4 762.3,464 912.3,464 1068.2,464 1191.2,464 1328.1,464 1440.1,464 1440.1,464 0,464; 0,464 0,367 111.6,263 282.5,282 457.4,323.3 613.4,340 762.3,425.6 912.3,464 1068.2,464 1191.2,464 1328.1,464 1440.1,464 1440.1,464 0,464; 0,464 0,367 111.6,263 282.5,282 457.4,263 613.4,290.4 762.3,368 912.3,446.4 1068.2,464 1191.2,464 1328.1,464 1440.1,464 1440.1,464 0,464; 0,464 0,367 111.6,263 282.5,282 457.4,263 613.4,216 762.3,329.6 912.3,420 1068.2,427.6 1191.2,464 1328.1,464 1440.1,464 1440.1,464 0,464; 0,464 0,367 111.6,263 282.5,282 457.4,263 613.4,216 762.3,272 912.3,402.4 1068.2,373 1191.2,412 1328.1,464 1440.1,464 1440.1,464 0,464; 0,464 0,367 111.6,263 282.5,282 457.4,263 613.4,216 762.3,272 912.3,376 1068.2,336.6 1191.2,334 1328.1,404 1440.1,464 1440.1,464 0,464; 0,464 0,367 111.6,263 282.5,282 457.4,263 613.4,216 762.3,272 912.3,376 1068.2,282 1191.2,282 1328.1,314 1440.1,372.8 1440.1,464 0,464; 0,464 0,367 111.6,263 282.5,282 457.4,263 613.4,216 762.3,272 912.3,376 1068.2,282 1191.2,204 1328.1,254 1440.1,236 1440.1,464 0,464; 0,464 0,367 111.6,263 282.5,282 457.4,263 613.4,216 762.3,272 912.3,376 1068.2,282 1191.2,204 1328.1,164 1440.1,144.79999999999998 1440.1,464 0,464; 0,464 0,367 111.6,263 282.5,282 457.4,263 613.4,216 762.3,272 912.3,376 1068.2,282 1191.2,204 1328.1,164 1440.1,8 1440.1,464 0,464;"
                fill="freeze"
              />
            </polygon>
          </g>
        </svg>
      </div>
      {/* </section> */}
      {/* ***** Hero Area End ***** */}
      {/* ***** Live Auctions Area Start ***** */}

      {/* ***** Live Auctions Area End ***** */}

      {/*====== Footer Area Start ======*/}
      <footer className="footer-area">
        {/* Footer Top */}
        <div className="footer-top">
          <div className="container">
            <div className="row">
              <div className="col-12 col-sm-6 col-lg-3 res-margin">
                {/* Footer Items */}
                <div className="footer-items">
                  {/* Logo */}
                  <a className="navbar-brand" href="index.html">
                    <img src="/assets/img/logo/logo.png" alt="" />
                  </a>
                  <p>
                    Padd Finance is the next generation community launchpad for
                    kucoin community chain projects. With Padd Finance, token
                    holders gain access to Pre-sale, Swap and Our Padd labs
                    program
                  </p>
                  {/* Social Icons */}
                  <div className="social-icons d-flex">
                    <a
                      className="twitter"
                      href=" https://twitter.com/PaddFinance"
                      target="_blank"
                    >
                      <i className="fab fa-twitter" />
                      <i className="fab fa-twitter" />
                    </a>
                    <a
                      className="discord"
                      href="https://discord.gg/DWExxmCcWf"
                      target="_blank"
                    >
                      <i className="fab fa-discord" />
                      <i className="fab fa-discord" />
                    </a>
                    <a
                      className="telegram"
                      href="https://t.me/paddFi "
                      target="_blank"
                    >
                      <i className="fab fa-telegram" />
                      <i className="fab fa-telegram" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-6 col-lg-3 res-margin">
                {/* Footer Items */}
                <div className="footer-items">
                  {/* Footer Title */}
                  <h4 className="footer-title">Useful Links</h4>
                  <ul>
                    <li>
                      <a href="/">Home</a>
                    </li>
                    <li>
                      <a
                        href="https://padd.finance/download/215/"
                        target="_blank"
                      >
                        Lite Paper
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-12 col-sm-6 col-lg-3 res-margin">
                {/* Footer Items */}
                <div className="footer-items">
                  {/* Footer Title */}
                  <h4 className="footer-title">Community</h4>
                  <ul>
                    <li>
                      <a href="https://t.me/paddFi " target="_blank">
                        Telegram Group
                      </a>
                    </li>
                    <li>
                      <a href="https://t.me/paddfinance" target="_blank">
                        Telegram Announcement Channel
                      </a>
                    </li>
                    <li>
                      <a href="https://padd.finance/blog/" target="_blank">
                        Padd Blog
                      </a>
                    </li>

                    <li>
                      <a href="https://padd.finance" target="_blank">
                        Official Website
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-12 col-sm-6 col-lg-3">
                {/* Footer Items */}
                <div className="footer-items">
                  {/* Footer Title */}
                  <h4 className="footer-title">Subscribe Us</h4>
                  {/* Subscribe Form */}
                  <div className="subscribe-form d-flex align-items-center">
                    <input
                      type="email"
                      className="form-control"
                      placeholder="info@yourmail.com"
                    />
                    <button type="submit" className="btn">
                      <i className="icon-paper-plane" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="container">
            <div className="row">
              <div className="col-12">
                {/* Copyright Area */}
                <div className="copyright-area d-flex flex-wrap justify-content-center justify-content-sm-between text-center py-4">
                  {/* Copyright Left */}
                  <div className="copyright-left">
                    ©{new Date().getFullYear()} Padd Finance, All Rights
                    Reserved.
                  </div>
                  {/* Copyright Right */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      {/*====== Footer Area End ======*/}

      {/*====== Modal Responsive Menu Area Start ======*/}
      <div id="menu" className="modal fade p-0">
        <div className="modal-dialog dialog-animated">
          <div className="modal-content h-100">
            <div className="modal-header" data-dismiss="modal">
              Menu <i className="far fa-times-circle icon-close" />
            </div>

           
    
                 <ul className="navbar-nav items mx-auto">
           <h3 className="m-0">  <a className="nav-link" href="/" style={{color : "white"}}>Home     </a></h3>
            </ul>
            <ul className="navbar-nav items mx-auto">
           <h3 className="m-0">  <a   className="nav-link"
                  target="_blank"
                  rel="norefferer"
                  href="https://padd.finance/download/215/" style={{color : "white"}}>      Lite Paper     </a></h3>
            </ul>
              {/* <li className="nav-item ">
                <a
                  className="nav-link"
                  target="_blank"
                  rel="norefferer"
                  href="https://padd.finance/download/215/"
                >
                  Lite Paper
                </a>
              </li> */}
         

            <div className="menu modal-body">
              <div className="row w-100">
                <div className="items p-0 col-12 text-center" />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*====== Modal Responsive Menu Area End ======*/}
      {/*====== Scroll To Top Area Start ======*/}
      <div id="scroll-to-top" className="scroll-to-top">
        <a href="#header" className="smooth-anchor">
          <i className="fas fa-arrow-up" />
        </a>
      </div>
      {/*====== Scroll To Top Area End ======*/}
    </div>
  );
}
